const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:[-+]\d{2}:?\d{2}|Z)?$/;

export const convertDates = (body: any): any => {
  if (body === null || body === undefined || typeof body !== 'object') return body;

  for (const key of Object.keys(body)) {
    const value = body[key];
    if (value && typeof value === 'string' && isoDateFormat.test(value)) {
      const hasTimezone = /([+-]\d{2}:?\d{2}|Z)$/.test(value);
      body[key] = new Date(hasTimezone ? value : value + 'Z');
    } else if (typeof value === 'object') {
      convertDates(value);
    }
  }
};
